var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsObject, IsOptional, IsUrl, IsUUID, ValidateNested, } from 'class-validator';
import { CallLiteDto } from '../../calls/dto/call.lite-dto.js';
import { CallPatientStatus } from '../../calls/enums/call-patient.enum.js';
import { ExerciseProgramMessageResponseDto, ExerciseProgramResponseDto, } from '../../exercise-programs/index.js';
import { UserProfileDto } from '../../user/index.js';
import { BookingDeclineReason } from '../../appointments/enums/booking-decline-reason.enum.js';
import { CancellationReason } from '../../appointments/enums/cancellation-reason.enum.js';
import { NotificationType } from '../enum/notificationType.enum.js';
import { NotificationAppointmentDto } from './notification-appointment.dto.js';
export class NotificationResponseDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    invoiceUrl;
    actor;
    actorId;
    recipient;
    recipientId;
    callId;
    call;
    appointmentId;
    appointment;
    exerciseProgramId;
    exercisePrograms;
    exerciseProgram;
    /**
     * The specific message ("Information für den Patienten") this notification was
     * created for. Rendered into the notification text and the email.
     */
    exerciseProgramMessage;
    type;
    actionTime;
    visible;
    /**
     * When the notification left the Offen lane. Null means Offen (PRD #1453).
     */
    archivedAt;
    ownParticipantStatus;
    newTherapist;
    newTherapistId;
    previousScheduledStart;
    newScheduledStart;
    /**
     * Fixed decline reason for a BOOKING_DECLINED notification (PRD #1343),
     * rendered to the patient verbatim. Null for every other type.
     */
    bookingDeclineReason;
    /**
     * The patient's reason for an APPOINTMENT_CANCELLED_BY_PATIENT notification
     * (TM-9535), as they picked it at the time. Rendered in-app only, never in
     * mail or push. Null for every other type.
     */
    cancellationReason;
    /**
     * For an APPOINTMENT_CANCELLED_BY_PATIENT notification (TM-9535): whether the
     * whole appointment ended at the time, or the patient only left a group
     * appointment. Null for every other type.
     */
    appointmentCancelled;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], NotificationResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], NotificationResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], NotificationResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "deletedAt", void 0);
__decorate([
    IsUrl(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "invoiceUrl", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "actor", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "actorId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", UserProfileDto)
], NotificationResponseDto.prototype, "recipient", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], NotificationResponseDto.prototype, "recipientId", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "callId", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => CallLiteDto),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "call", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "appointmentId", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Expose(),
    Type(() => NotificationAppointmentDto),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "appointment", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "exerciseProgramId", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseProgramResponseDto),
    ValidateNested({ each: true }),
    Expose(),
    __metadata("design:type", Array)
], NotificationResponseDto.prototype, "exercisePrograms", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "exerciseProgram", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Expose(),
    Type(() => ExerciseProgramMessageResponseDto),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "exerciseProgramMessage", void 0);
__decorate([
    IsEnum(NotificationType),
    Expose(),
    __metadata("design:type", String)
], NotificationResponseDto.prototype, "type", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], NotificationResponseDto.prototype, "actionTime", void 0);
__decorate([
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], NotificationResponseDto.prototype, "visible", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "archivedAt", void 0);
__decorate([
    IsOptional(),
    IsEnum(CallPatientStatus),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "ownParticipantStatus", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "newTherapist", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "newTherapistId", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "previousScheduledStart", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "newScheduledStart", void 0);
__decorate([
    IsOptional(),
    IsEnum(BookingDeclineReason),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "bookingDeclineReason", void 0);
__decorate([
    IsOptional(),
    IsEnum(CancellationReason),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "cancellationReason", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "appointmentCancelled", void 0);
//# sourceMappingURL=notification.response.dto.js.map